<template>
  <div id="bto-radar-chart-wrap">
    <canvas id="bto-radar-chart">
      <p>運勢チャート</p>
    </canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "AccessoryInfoChart",

  props: {},

  data() {
    return {
      chartInstance: null,
    };
  },

  computed: {
    /**
     * 運勢チャートパラメータを返す
     */
    chartData: {
      get() {
        let res = this.$store.state.result;
        if (!res.param) {
          return [];
        }

        let params = res.param;
        return [
          params.s_luck,
          params.s_guard,
          params.s_gold,
          params.s_job,
          params.s_dream,
          params.s_relation,
          params.s_love,
          params.s_health,
          params.s_heal,
          params.s_mind,
        ];
      },
    },
  },

  watch: {
    chartData: function () {
      this.createChart();
    },
  },

  mounted() {
    this.createChart();
  },

  methods: {
    /**
     * chart.jsを使用したレーダーチャートを作成する
     */

    createChart() {
      if (typeof this.chartInstance !== "undefined" && this.chartInstance) {
        this.chartInstance.destroy();
      }

      let ctx = document.getElementById("bto-radar-chart");
      if (null == ctx) {
        return false;
      }

      let data = {
        labels: [
          "幸運",
          "お守",
          "金運",
          "仕事",
          "願望",
          "対人",
          "恋愛",
          "健康",
          "癒し",
          "精神",
        ],
        datasets: [
          {
            label: "",
            data: this.chartData,
            fill: true,
            backgroundColor: "RGBA(255,255,255, 0.5)",
            borderColor: "#ffa706",
            pointBackgroundColor: "RGB(255,255,255)",
            pointBorderColor: "#ffa706",
            pointHoverBackgroundColor: "#ffa706",
            pointHoverBorderColor: "RGB(255,255,255)",
          },
        ],
      };

      let opt = {
        type: "radar",
        data: data,
        options: {
          events: ["click"],
          resizeDelay: 500,

          layout: {
            padding: {
              left: 5,
              right: 5,
              top: 2,
              bottom: 2,
            },
          },

          plugins: {
            legend: {
              display: false,
            },

            title: {
              display: false,
            },

            tooltip: {
              enabled: false,
            },
          },

          elements: {
            line: {
              borderWidth: 2,
              tension: 0,
              spangaps: false,
            },
            point: {
              pointBorderWidth: 3,
            },
          },

          scales: {
            r: {
              suggestedMin: 0,
              suggestedMax: 100,
              title: {
                display: false,
              },
              grid: {
                display: true,
                circular: true,
                color: ["#cccccc", "#eeeeee", "#eeeeee"],
              },
              ticks: {
                display: false,
              },
            },
          },

          responsive: true,
          maintainAspectRatio: true,
        },
      };

      this.chartInstance = new Chart(ctx, opt);
    },
  },
};
</script>

<style scoped lang="stylus">

@css {
  #bto-radar-chart-wrap {
    @apply bg-white mx-2
  }
}
</style>
